<template>
	<div class="flex-grow flex flex-col">
		<BaseInput label="IMD-CONNECT Nummer" v-model="imdNet"></BaseInput>
		<BaseInput :label="$t('password')" type="password" v-model="password"></BaseInput>
		<BaseButton @click="login" class="btn-blue w-full mt-4 h-16">Login</BaseButton>
		<div class="my-8 text-red-700 font-bold text-2xl" v-if="loginError">
			Login fehlerhaft!
		</div>
		<div class="flex-grow flex"></div>
		<div>
			<BaseBackButton @click="$router.push({ name: 'AppsEmployeeStart' })" class="flex my-8 justify-center w-full"></BaseBackButton>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseButton from '@/components/forms/buttons/BaseButton';
import AppsEmployee from '@/mixins/AppsEmployee';
import BaseBackButton from '@/components/forms/buttons/BaseBackButton';
import { AuthenticationApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import store from '@/store';

export default {
	name: 'AppsEmployeeLogin',
	components: { BaseBackButton, BaseButton, BaseInput },
	mixins: [AppsEmployee],
	data() {
		return {
			imdNet: null,
			password: null,
			loginError: false,
		};
	},
	methods: {
		login() {
			this.loginError = false;
			this.loginMitarbeiterApp(this.imdNet, this.password, false)
				.then(response => {
					this.$router.push({ name: 'AppsEmployeeMain' });
				})
				.catch(error => {
					this.loginError = true;
				});
		},
		loginMitarbeiterApp(imdnet, qrkey, isPassword = false) {
			const loginObject = isPassword ? { imdnet: imdnet, password: qrkey } : { imdnet: imdnet, qrkey: qrkey };
			return AuthenticationApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.appsEmployeeLoginPost(loginObject)
				.then(result => {
					if (result.data.id) {
						store.commit('setAppsEmployeeDamageCase', result.data);
						store.commit('setAppsEmployeeLoginStatus', true);
						store.commit('setAppsEmployeeLoginStatusCode', null);
					} else {
						store.commit('setAppsEmployeeLoginStatusCode', result.data.error_id);
					}
				})
				.catch(error => {
					store.commit('setAppsEmployeeLoginStatusCode', 901);
				});
		},
	},
};
</script>

<style scoped></style>
